'use strict';

var ReviewInputDataChartDirective = function ReviewInputDataChartDirective(Chart) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/review-input-data-chart.html'),
    controller: 'ReviewInputDataChartController',
    scope: {
      calendar: '='
    },
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var chart = new Chart(chartElement, scope.chartFormatters);
      scope.renderChartDataPresent = function (data) {
        chart.withMetric(scope.selectedMetric).withDisplayMode(scope.filter.displayMode).render(data);
      };
      scope.setInitialSelection = function (range) {
        chart.setInitialSelection(range);
      };
      scope.$watch('calendar.metric', scope.changeMetricHandler);
      scope.$watchGroup(['calendar.dateRangeFrom', 'calendar.dateRangeTo'], scope.updateChart);
      scope.$on('context-menu:input-data-chart-mark-exclusion', function () {
        scope.createUserExclusionEvent(chart.getSelection());
      });
    }
  };
};
ReviewInputDataChartDirective.$inject = ['ReviewInputDataChart'];
module.exports = ReviewInputDataChartDirective;